<div class="container-fluid">
  <div class="row manageaccount mt-3">
    <div class="col-md-12 my-auto">
      <div class="d-flex align-items-baseline justify-content-between">
        <h1 class="fs-4 fw-bold mb-0">Add New Tracker</h1>
        <button
          class="btn btn-dark btn-sm"
          matTooltip="Back"
          matTooltipPosition="left"
          mat-raised-button
          (click)="backTo()"
        >
          <i class="fa-solid fa-arrow-left"></i>
        </button>
      </div>
      <nav class="breadcrumbMaine" aria-label="breadcrumb mb-0">
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item" routerLink="/superAdmin/lrmanagement">
            Manage LR
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            Add New Tracker
          </li>
        </ol>
      </nav>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-xl-12">
      <form [formGroup]="addNewLR" (ngSubmit)="addNewTrackerSubmit()">
        <!-- basic information -->
        <div class="contentbox mb-3">
          <div class="row account">
            <!-- Basic Details Section -->
            <div class="col-xl-12">
              <!-- Vehicle Information Section -->
              <div class="row">
                <div class="col-md-12 border-bottom pb-3 border-gray mb-3">
                  <h4 class="text-dark fw-bold mb-0">Basic Details</h4>
                </div>

                <!-- First Row -->
                <div class="row">
                  <div
                    class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3"
                    *ngIf="userSessionData?.user_role_id[0] == 1"
                  >
                    <div class="form-group accountsinp mb-3">
                      <label for="">Supervisor Name </label>
                      <select
                        id="supervisornamectrl"
                        formControlName="supervisorname"
                        placeholder="Select Status"
                        class="form-control shadow-none"
                      >
                        <option selected disabled value="">
                          --Select Supervisor Name--
                        </option>
                        <option
                          *ngFor="let s of superVisor"
                          value="{{ s._id }}"
                        >
                          {{ s.full_name }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <!-- FIX/Adhoc -->
                  <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                    <div class="form-group accountsinp mb-3">
                      <label for="clientListctrl"
                        >Company Name<sup class="text-danger">*</sup></label
                      >

                      <select
                        id="clientListctrl"
                        formControlName="clientList"
                        placeholder="Select Client Name"
                        class="form-control shadow-none"
                        (change)="onKeyClientName($event)"
                      >
                        <option disabled value="">
                          --Select Company Name--
                        </option>
                        <option
                          *ngFor="let cl of clientList"
                          value="{{ cl?._id }}"
                        >
                          {{ cl?.clientName }}
                        </option>
                      </select>
                      <span
                        class="text-danger"
                        *ngIf="
                          ff.clientList.invalid &&
                          (ff.clientList.touched || submitLRClicked)
                        "
                      >
                        Please select Company Name
                      </span>
                    </div>
                  </div>

                  <!-- Date -->
                  <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
                    <div class="form-group accountsinp mb-3">
                      <label for="datectrl"
                        >Date<sup class="text-danger">*</sup></label
                      >
                      <input
                        type="date"
                        id="datectrl"
                        class="form-control shadow-none"
                        placeholder="Enter Date"
                        formControlName="date"
                        (change)="onKeyDate($event)"
                        [min]="isSupervisor ? yesterday : null"
                        [max]="isSupervisor ? today : null"
                      />
                      <span
                        class="text-danger"
                        *ngIf="
                          ff.date.invalid &&
                          (ff.date.touched || submitLRClicked)
                        "
                      >
                        Please enter date
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Vehicle Information -->
        <div class="contentbox">
          <div class="row account">
            <div class="col-xl-12">
              <!-- Vehicle Information Section -->
              <div class="row">
                <div class="col-md-12 border-bottom pb-3 border-gray mb-3">
                  <h4 class="text-dark fw-bold mb-0">Vehicle Information</h4>
                </div>

                <!-- First Row -->
                <div class="row">
                  <!-- Vehicle Number -->
                  <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                    <div class="form-group accountsinp mb-3">
                      <label for="VehicleNoctrl"
                        >Vehicle No.<sup class="text-danger">*</sup></label
                      >
                      <input
                        type="text"
                        id="VehicleNoctrl"
                        class="form-control shadow-none"
                        placeholder="Enter Vehicle No."
                        formControlName="VehicleNo"
                        [matAutocomplete]="autoVehicleNum"
                      />
                      <mat-autocomplete
                        autoActiveFirstOption
                        #autoVehicleNum="matAutocomplete"
                        (optionSelected)="getVehicleTypeFromNumber($event)"
                      >
                        <mat-option
                          *ngFor="let option of filteredVehicleNo | async"
                          [value]="option"
                        >
                          {{ option }}
                        </mat-option>
                      </mat-autocomplete>

                      <span
                        class="text-danger"
                        *ngIf="
                          ff.VehicleNo.invalid &&
                          (ff.VehicleNo.touched || submitLRClicked)
                        "
                      >
                        Please enter Vehicle number
                      </span>
                    </div>
                  </div>

                  <!-- Vehicle Type -->
                  <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                    <div class="form-group accountsinp">
                      <label for="vehicleTypectrl">Vehicle Type</label>
                      <input
                        type="text"
                        id="vehicleTypectrl"
                        class="form-control shadow-none"
                        placeholder="Enter Vehicle Type"
                        formControlName="vehicleType"
                        (keyup)="onKeyVehicleType($event)"
                        [matAutocomplete]="autoVehicleType"
                      />
                      <mat-autocomplete
                        autoActiveFirstOption
                        #autoVehicleType="matAutocomplete"
                      >
                        <mat-option
                          *ngFor="let option of filteredVehicleTypes | async"
                          [value]="option"
                        >
                          {{ option }}
                        </mat-option>
                      </mat-autocomplete>
                    </div>
                  </div>

                  <!-- FIX/Adhoc -->
                  <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                    <div class="form-group accountsinp">
                      <label for="fixAdhocctrl"
                        >FIX / Adhoc<sup class="text-danger">*</sup></label
                      >
                      <select
                        formControlName="fixAdhoc"
                        id="fixAdhocctrl"
                        class="form-control shadow-none"
                        (change)="onKeyFixAdhoc($event)"
                      >
                        <option disabled value="">--Select FIX/Adhoc--</option>
                        <option value="FIX">FIX</option>
                        <option value="Adhoc">Adhoc</option>
                        <option value="Replacement">Replacement</option>
                      </select>
                      <span
                        class="text-danger"
                        *ngIf="
                          ff.fixAdhoc.invalid &&
                          (ff.fixAdhoc.touched || submitLRClicked)
                        "
                      >
                        Please enter Fix / Adhoc
                      </span>
                    </div>
                  </div>
                </div>

                <!-- Second Row -->
                <div class="row">
                  <!-- From -->
                  <div class="col-lg-4 col-md-6 col-sm-6 col-12 mb-3">
                    <div class="form-group accountsinp">
                      <label for="fromctrl"
                        >From<sup class="text-danger">*</sup></label
                      >
                      <input
                        type="text"
                        id="fromctrl"
                        class="form-control shadow-none"
                        placeholder="Enter From"
                        formControlName="from"
                        (keyup)="onKeyFrom($event)"
                      />
                      <span
                        class="text-danger"
                        *ngIf="
                          ff.from.invalid &&
                          (ff.from.touched || submitLRClicked)
                        "
                      >
                        Please enter value
                      </span>
                    </div>
                  </div>

                  <!-- To -->
                  <div class="col-lg-4 col-md-6 col-sm-6 col-12 mb-3">
                    <div class="form-group accountsinp">
                      <label for="toctrl"
                        >To<sup class="text-danger">*</sup></label
                      >
                      <input
                        type="text"
                        id="toctrl"
                        class="form-control shadow-none"
                        placeholder="Enter To"
                        formControlName="to"
                        (keyup)="onKeyTo($event)"
                      />
                      <span
                        class="text-danger"
                        *ngIf="
                          ff.to.invalid && (ff.to.touched || submitLRClicked)
                        "
                      >
                        Please enter value
                      </span>
                    </div>
                  </div>

                  <!-- Fixed KM -->
                  <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                    <div class="form-group accountsinp">
                      <label for="fixedKMctrl">Fixed KM</label>
                      <input
                        type="number"
                        id="fixedKMctrl"
                        class="form-control shadow-none"
                        placeholder="Enter Fixed KM"
                        formControlName="fixedKM"
                      />
                      <span class="text-danger" *ngIf="ff.fixedKM.invalid && ff.fixedKM.touched">
                        Only numbers should be accepted
                      </span>
                    </div>
                  </div>

                  <!-- Extra KM Cost -->
                  <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                    <div class="form-group accountsinp">
                      <label for="extraKMCostctrl">Extra KM Cost (Per Km)</label>
                      <input
                        type="number"
                        id="extraKMCostctrl"
                        class="form-control shadow-none"
                        placeholder="Enter Extra KM Cost"
                        formControlName="extraKMCost"
                      />
                      <span class="text-danger" *ngIf="ff.extraKMCost.invalid && ff.extraKMCost.touched">
                        Only numbers should be accepted
                      </span>
                    </div>
                  </div>

                  <!-- Variable Cost/Hr -->
                  <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                    <div class="form-group accountsinp">
                      <label for="variableCostHrctrl">Variable Cost/Hr</label>
                      <input
                        type="number"
                        id="variableCostHrctrl"
                        class="form-control shadow-none"
                        placeholder="Enter Variable Cost/Hr"
                        formControlName="variableCostHr"
                      />
                      <span class="text-danger" *ngIf="ff.variableCostHr.invalid && ff.variableCostHr.touched">
                        Only numbers should be accepted
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Trip information -->
        <div class="contentbox mt-3">
          <div class="row account">
            <div class="col-md-12 border-bottom pb-3 border-gray mb-3">
              <h4 class="text-dark fw-bold mb-0">Trip Details</h4>
            </div>
            <div class="col-xl-12">
              <div class="row">
                <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
                  <div class="form-group accountsinp mb-3">
                    <label for=""
                      >Starting Meter Reading<sup class="text-danger"
                        >*</sup
                      ></label
                    >
                    <div class="align-items-center">
                      <input
                        type="number"
                        class="form-control me-1 shadow-none"
                        placeholder="Enter Meter Reading"
                        id="startmeterReadingctrl"
                        formControlName="startmeterReading"
                        (keyup)="onKeyStartMeterReading($event)"
                      />
                      <span
                        class="text-danger"
                        *ngIf="
                          ff.startmeterReading.invalid &&
                          (ff.startmeterReading.touched || submitLRClicked)
                        "
                      >
                        Please enter Start Meter Reading
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
                  <div class="form-group accountsinp mb-3">
                    <label for=""
                      >End Meter Reading<sup class="text-danger">*</sup></label
                    >
                    <div class="align-items-center">
                      <input
                        type="number"
                        class="form-control me-1 shadow-none"
                        placeholder="Enter  Meter Reading"
                        id="endmeterReadingctrl"
                        (change)="onFocusOutendmeterReading($event)"
                        formControlName="endmeterReading"
                        (keyup)="onKeyEndMeterReading($event)"
                      />
                      <span
                        class="text-danger"
                        *ngIf="
                          ff.endmeterReading.invalid &&
                          (ff.endmeterReading.touched || submitLRClicked)
                        "
                      >
                        Please enter Start Meter Reading
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
                  <div class="form-group accountsinp mb-3">
                    <label for=""
                      >Trip Starting Date<sup class="text-danger">*</sup></label
                    >
                    <div class="d-flex align-items-center">
                      <input
                        type="date"
                        class="form-control me-1 shadow-none"
                        placeholder="Enter Start Time"
                        id="tripSDatectrl"
                        formControlName="tripSDate"
                      />
                    </div>
                    <span
                      class="text-danger"
                      *ngIf="
                        ff.tripSDate.invalid &&
                        (ff.tripSDate.touched || submitLRClicked)
                      "
                    >
                      Please enter Trip Starting Date
                    </span>
                  </div>
                </div>
                <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
                  <div class="form-group accountsinp mb-3">
                    <label for="">Trip End Date</label>
                    <div class="d-flex align-items-center">
                      <input
                        type="date"
                        class="form-control me-1 shadow-none"
                        placeholder="Enter End Time"
                        id="tripEDatectrl"
                        formControlName="tripEDate"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
                  <div class="form-group accountsinp mb-3">
                    <label for=""
                      >Trip Starting Time<sup class="text-danger">*</sup></label
                    >
                    <div class="d-flex align-items-center">
                      <input
                        type="time"
                        class="form-control me-1 shadow-none"
                        placeholder="Enter Start Time"
                        id="outtimectrl"
                        formControlName="outtime"
                      />
                    </div>
                    <span
                      class="text-danger"
                      *ngIf="
                        ff.outtime.invalid &&
                        (ff.outtime.touched || submitLRClicked)
                      "
                    >
                      Please enter Trip Starting Time
                    </span>
                  </div>
                </div>
                <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
                  <div class="form-group accountsinp mb-3">
                    <label for="">Trip End Time</label>
                    <div class="d-flex align-items-center">
                      <input
                        type="time"
                        class="form-control me-1 shadow-none"
                        placeholder="Enter End Time"
                        (change)="onFocusOuttripEDate($event)"
                        id="INtimectrl"
                        formControlName="INtime"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- usesage and tolls -->
        <div class="contentbox mt-3">
          <div class="row account">
            <div class="col-md-12 border-bottom pb-3 border-gray mb-3">
              <h4 class="text-dark fw-bold mb-0">Usage & Tolls</h4>
            </div>
            <div class="col-xl-12">
              <div class="row">
                <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
                  <div class="form-group accountsinp mb-3">
                    <label for="">Number of Tolls</label>
                    <div class="align-items-center">
                      <input
                        type="number"
                        class="form-control me-1 shadow-none"
                        placeholder="Enter Tolls"
                        id="noofToolsctrl"
                        formControlName="noofTools"
                      />
                      <span
                        class="text-danger"
                        *ngIf="ff.noofTools.invalid && ff.noofTools.touched"
                      >
                        Only numbers should be accepted
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
                  <div class="form-group accountsinp mb-3">
                    <label for="">Total Toll Tax Paid</label>
                    <div class="align-items-center">
                      <input
                        type="number"
                        class="form-control me-1 shadow-none"
                        placeholder="Enter Tolls Tax Paid"
                        id="tooltaxPaidctrl"
                        formControlName="tooltaxPaid"
                      />
                      <span
                        class="text-danger"
                        *ngIf="ff.tooltaxPaid.invalid && ff.tooltaxPaid.touched"
                      >
                        Only numbers should be accepted
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
                  <div class="form-group accountsinp mb-3">
                    <label for="">Usage KM</label>
                    <div class="align-items-center">
                      <input
                        disabled
                        type="text"
                        class="form-control me-1 shadow-none"
                        placeholder="KM"
                        id="updownkmctrl"
                        readonly
                        formControlName="updownkm"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
                  <div class="form-group accountsinp mb-3">
                    <label for="">Total Hours</label>
                    <div class="align-items-center">
                      <input
                        disabled
                        type="number"
                        class="form-control me-1 shadow-none"
                        placeholder="Total Hours"
                        id="totalhourctrl"
                        readonly
                        formControlName="totalhour"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
                  <div class="form-group accountsinp mb-3">
                    <label for="">Extra Hours</label>
                    <div class="align-items-center">
                      <input
                        type="number"
                        class="form-control me-1 shadow-none"
                        placeholder="Extra Hours"
                        id="extrahourctrl"
                        formControlName="extrahour"
                      />
                      <span
                        class="text-danger"
                        *ngIf="ff.extrahour.invalid && ff.extrahour.touched"
                      >
                        Only numbers should be accepted
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Payment -->
        <div class="contentbox mt-3">
          <div class="row account">
            <div class="col-md-12 border-bottom pb-3 border-gray mb-3">
              <h4 class="text-dark fw-bold mb-0">Payment</h4>
            </div>
            <div class="col-xl-12">
              <div class="row">
                <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
                  <div class="form-group accountsinp mb-3">
                    <label for=""
                      >Vehicle Rate<sup class="text-danger">*</sup></label
                    >
                    <div class="align-items-center">
                      <input
                        type="number"
                        class="form-control me-1 shadow-none"
                        placeholder="Vehicle Rate"
                        id="vehicleRatectrl"
                        formControlName="vehicleRate"
                      />
                      <span
                        class="text-danger"
                        *ngIf="
                          ff.vehicleRate.invalid &&
                          (ff.vehicleRate.touched || submitLRClicked)
                        "
                      >
                        Please enter Vehicle Rate
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
                  <div class="form-group accountsinp mb-3">
                    <label for=""
                      >Advance<sup class="text-danger">*</sup></label
                    >
                    <div class="align-items-center">
                      <input
                        type="number"
                        class="form-control me-1 shadow-none"
                        placeholder="Advance"
                        id="advancectrl"
                        formControlName="advance"
                      />
                      <span
                        class="text-danger"
                        *ngIf="
                          ff.advance.invalid &&
                          (ff.advance.touched || submitLRClicked)
                        "
                      >
                        Please enter Advance
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
                  <div class="form-group accountsinp mb-3">
                    <label for=""
                      >Balance Paid<sup class="text-danger">*</sup></label
                    >
                    <div class="align-items-center">
                      <input
                        type="number"
                        class="form-control me-1 shadow-none"
                        placeholder="Balance Paid"
                        (change)="onFocusOutEvent($event)"
                        id="balancePaidctrl"
                        formControlName="balancePaid"
                      />
                      <span
                        class="text-danger"
                        *ngIf="
                          ff.balancePaid.invalid &&
                          (ff.balancePaid.touched || submitLRClicked)
                        "
                      >
                        Please enter Paid Balance
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
                  <div class="form-group accountsinp mb-3">
                    <label for="">Actual Balance</label>
                    <div class="align-items-center">
                      <input
                        type="number"
                        class="form-control me-1 shadow-none"
                        placeholder="Actual Balance"
                        disabled
                        id="balancectrl"
                        readonly
                        formControlName="balance"
                      />
                    </div>
                  </div>
                </div>

                <!-- TDS -->
                <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
                  <div class="form-group accountsinp mb-3">
                    <label>TDS</label>
                    <input
                      type="number"
                      class="form-control shadow-none"
                      placeholder="TDS"
                      id="TDSctrl"
                      formControlName="TDS"
                    />
                  </div>
                </div>

                <!-- Munsipal Amount -->
                <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
                  <div class="form-group accountsinp mb-3">
                    <label>Munsipal Amount</label>
                    <input
                      type="number"
                      class="form-control shadow-none"
                      placeholder="Munsipal Amount"
                      id="munsipalAmountctrl"
                      formControlName="munsipalAmount"
                    />
                  </div>
                </div>

                <!-- Final Amount (MANUAL INPUT) -->
                <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
                  <div class="form-group accountsinp mb-3">
                    <label>Final Amount</label>
                    <input
                      type="number"
                      class="form-control shadow-none"
                      placeholder="Final Amount"
                      id="finalAmountctrl"
                      formControlName="finalAmount"
                    />
                  </div>
                </div>

                <!-- Fixed Payment -->
                <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
                  <div class="form-group accountsinp mb-3">
                    <label>Fixed Payment</label>
                    <input
                      type="number"
                      class="form-control shadow-none"
                      placeholder="Fixed Payment"
                      id="fixedPaymentctrl"
                      formControlName="fixedPayment"
                    />
                  </div>
                </div>

                <!-- Fixed Payment/Month -->
                <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
                  <div class="form-group accountsinp mb-3">
                    <label>Fixed Payment/Month</label>
                    <input
                      type="number"
                      class="form-control shadow-none"
                      placeholder="Fixed Payment/Month"
                      id="fixedPaymentMonthctrl"
                      formControlName="fixedPaymentMonth"
                    />
                  </div>
                </div>

                <!-- Other Payment -->
                <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
                  <div class="form-group accountsinp mb-3">
                    <label>Other Payment</label>
                    <input
                      type="number"
                      class="form-control shadow-none"
                      placeholder="Other Payment"
                      id="otherPaymentctrl"
                      formControlName="otherPayment"
                    />
                  </div>
                </div>

                <!-- Other Payment Description -->
                <div class="col-lg-6 col-xl-6 col-sm-12 col-12 col-md-6">
                  <div class="form-group accountsinp mb-3">
                    <label>Other Payment Description</label>
                    <input
                      type="text"
                      class="form-control shadow-none"
                      placeholder="Other Payment Description"
                      id="otherPaymentDescriptionctrl"
                      formControlName="otherPaymentDescription"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Compliance & Value -->
        <div class="contentbox mt-3">
          <div class="row account">
            <!-- Basic Details Section -->
            <div class="col-xl-12">
              <!-- Vehicle Information Section -->
              <div class="row">
                <div class="col-md-12 border-bottom pb-3 border-gray mb-3">
                  <h4 class="text-dark fw-bold mb-0">Compliance & Value</h4>
                </div>

                <!-- First Row -->
                <div class="row">
                  <!-- DLY -->
                  <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
                    <div class="form-group accountsinp mb-3">
                      <label for="DLYctrl">DLY</label>
                      <input
                        type="text"
                        id="DLYctrl"
                        class="form-control shadow-none"
                        placeholder="Enter DLY"
                        formControlName="DLY"
                        (keyup)="onKeyDLY($event)"
                      />
                      <span
                        class="text-danger"
                        *ngIf="
                          ff.DLY.invalid && (ff.DLY.touched || submitLRClicked)
                        "
                      >
                        Please enter DLY
                      </span>
                    </div>
                  </div>
                  <!-- Order Id -->
                  <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                    <div class="form-group accountsinp mb-3">
                      <label for="orderIdctrl">Order Id</label>
                      <div class="d-flex align-items-center">
                        <input
                          type="text"
                          class="form-control me-1 shadow-none"
                          id="orderIdctrl"
                          placeholder="Enter order Id."
                          formControlName="orderId"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Add invoice -->
        <div class="contentbox mt-3">
          <div class="row account">
            <div class="col-12 border-bottom pb-3 mb-3 border-gray">
              <h4 class="text-dark fw-bold mb-0">Invoice Section</h4>
            </div>

            <!-- Invoice Number -->
            <div class="row">
              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <label for="InvoiceNoctrl" class="form-label"
                  >Invoice No<sup class="text-danger">*</sup></label
                >
              </div>
              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <input
                  type="text"
                  id="InvoiceNoctrl"
                  formControlName="InvoiceNo"
                  class="form-control shadow-none"
                  placeholder="Enter the invoice number"
                  (keyup)="onKeyInvoiceNo($event)"
                />
                <span
                  class="text-danger"
                  *ngIf="ff.InvoiceNo.invalid && ff.InvoiceNo.touched"
                >
                  Only numbers should be accepted
                </span>
              </div>
            </div>
            <!-- Invoice Value -->
            <div class="row">
              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <label for="InvoiceValuectrl" class="form-label"
                  >Invoice Value<sup class="text-danger">*</sup></label
                >
              </div>
              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <input
                  type="text"
                  id="InvoiceValuectrl"
                  formControlName="InvoiceValue"
                  class="form-control shadow-none"
                  placeholder="Enter the total value"
                  (keyup)="onKeyInvoiceValue($event)"
                />
                <span
                  class="text-danger"
                  *ngIf="InvoiceValue?.invalid && InvoiceValue.touched"
                >
                  Only numbers should be accepted
                </span>
              </div>
            </div>

            <!-- Number of Articles -->
            <div class="row">
              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <label for="NoofArticlectrl" class="form-label"
                  >Number of Articles<sup class="text-danger">*</sup></label
                >
              </div>
              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <input
                  type="text"
                  id="NoofArticlectrl"
                  formControlName="NoofArticle"
                  class="form-control shadow-none"
                  placeholder="Enter total articles"
                  (keyup)="onKeyNoofArticle($event)"
                />
                <span
                  class="text-danger"
                  *ngIf="NoofArticle.invalid && NoofArticle.touched"
                >
                  Only numbers should be accepted
                </span>
              </div>
            </div>

            <!-- Weight -->
            <div class="row">
              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <label for="Weightctrl" class="form-label"
                  >Weight<sup class="text-danger">*</sup></label
                >
              </div>
              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <input
                  type="text"
                  id="Weightctrl"
                  formControlName="Weight"
                  class="form-control shadow-none"
                  placeholder="Enter total weight"
                  (keyup)="onKeyWeight($event)"
                />
                <span
                  class="text-danger"
                  *ngIf="Weight.invalid && Weight.touched"
                >
                  Only numbers should be accepted
                </span>
              </div>
            </div>
            <!-- Customer Name -->
            <div class="row">
              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <label for="customerNamectrl" class="form-label"
                  >Customer Name<sup class="text-danger">*</sup></label
                >
              </div>
              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <input
                  type="text"
                  id="customerNamectrl"
                  formControlName="customerName"
                  class="form-control shadow-none"
                  placeholder="Enter customer name"
                  (keyup)="onKeyCustomerName($event)"
                />
              </div>
            </div>

            <!-- Proof of Delivery -->
            <div class="row">
              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <label for="">Proof of Delivery</label>
              </div>
              <div
                class="col-12 col-md-6 col-lg-4 mb-3 d-flex align-items-center"
              >
                <input
                  type="file"
                  accept="image/*,.pdf,.doc"
                  (change)="fileChangeEventAttachment($event)"
                  class="form-control me-1 shadow-none"
                  id="PODctrl"
                  formControlName="POD"
                />
                <a #showPOD [href]="podURL" target="_blank"></a>
                <button
                  (click)="previewPOD()"
                  mat-raised-button
                  matTooltip="Preview"
                  class="btn btn-dark ms-2"
                  type="submit"
                >
                  <i class="fa-solid fa-eye"></i>
                </button>

                <button
                  type="button"
                  class="btn btn-dark ms-2"
                  style="width: 40%"
                  (click)="addInvoiceDetail()"
                >
                  Save Invoice
                </button>
              </div>
            </div>
          </div>

          <!-- Table Section -->
          <div class="row mt-3" *ngIf="InvoiceDetails.filteredData.length > 0">
            <div class="col-12 contentbox">
              <table
                mat-table
                [dataSource]="InvoiceDetails"
                class="mat-elevation-z8 w-100"
              >
                <ng-container matColumnDef="invoiceNo">
                  <th mat-header-cell *matHeaderCellDef>Invoice No.</th>
                  <td mat-cell *matCellDef="let inv">{{ inv.InvoiceNo }}</td>
                </ng-container>

                <ng-container matColumnDef="invoiceValue">
                  <th mat-header-cell *matHeaderCellDef>Invoice Value</th>
                  <td mat-cell *matCellDef="let inv">{{ inv.InvoiceValue }}</td>
                </ng-container>

                <ng-container matColumnDef="noOfArticle">
                  <th mat-header-cell *matHeaderCellDef>NO of Article</th>
                  <td mat-cell *matCellDef="let inv">{{ inv.NoofArticle }}</td>
                </ng-container>

                <ng-container matColumnDef="weight">
                  <th mat-header-cell *matHeaderCellDef>Weight</th>
                  <td mat-cell *matCellDef="let inv">{{ inv.Weight }}</td>
                </ng-container>

                <ng-container matColumnDef="customerName">
                  <th mat-header-cell *matHeaderCellDef>Customer Name</th>
                  <td mat-cell *matCellDef="let inv">{{ inv.customerName }}</td>
                </ng-container>

                <ng-container matColumnDef="pod">
                  <th mat-header-cell *matHeaderCellDef class="text-center">
                    POD
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let inv; let i = index"
                    class="text-center"
                  >
                    <button
                      type="button"
                      class="btn btn-dark btn-sm px-4"
                      (click)="preview(i)"
                    >
                      Preview
                    </button>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: displayedColumns"
                ></tr>
              </table>
            </div>
          </div>
        </div>

        <div class="col-xl-12 text-end mt-3">
          <button
            class="btn btn-dark"
            type="button"
            (click)="resetForm()"
            mat-raised-button
          >
            Reset
          </button>
          <button class="btn btn-dark ms-2" type="submit" mat-raised-button>
            Save
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
